import { getCsrfValue } from "../ApiHelper";
import { resolveApiUrl } from "../../utils/url/urlResolver";

const apiUrl = resolveApiUrl("/quote/account");

export function sendData(data: { accountId?: string; salesOrg?: string; endCustomerCode?: string }) {
  // Creates an url in format: basePath/accountId/salesOrg/endCustomerCode skipping all missing properties
  const url = [apiUrl, data.accountId, data.salesOrg, data.endCustomerCode].filter(Boolean).join("/");

  return fetch(url, {
    method: "GET",
    cache: "no-cache",
    credentials: "same-origin", // include, omit
    mode: "cors", // no-cors, same-origin
    referrer: "no-referrer", // client
    headers: {
      CSRFToken: getCsrfValue(),
    },
  }).then((response) => {
    if (response.ok) {
      return response;
    }
    throw new Error(response.status + "");
  });
}
